/**
 * RealNotificationProvider - Sonner toasts + canvas-confetti
 *
 * Uses sonner for toast notifications and canvas-confetti for celebrations.
 */

import { toast } from 'sonner';
import confetti from 'canvas-confetti';
import { NotificationProvider, NotificationType } from '../types';

export class RealNotificationProvider implements NotificationProvider {
  showNotification(message: string, type: NotificationType, duration?: number): void {
    const opts = duration ? { duration } : undefined;
    switch (type) {
      case 'success':
        toast.success(message, opts);
        break;
      case 'error':
        toast.error(message, opts);
        break;
      case 'warning':
        toast.warning(message, opts);
        break;
      case 'info':
        toast.info(message, opts);
        break;
    }
  }

  showSuccess(message: string, duration?: number): void {
    this.showNotification(message, 'success', duration);
  }

  showError(message: string, duration?: number): void {
    this.showNotification(message, 'error', duration);
  }

  showWarning(message: string, duration?: number): void {
    this.showNotification(message, 'warning', duration);
  }

  async showCelebration(message?: string): Promise<void> {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });

    if (message) {
      toast.success(message);
    }
  }
}
